<template>
  <div v-if="!loading">
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.SoftPolisherDealk.systemSpecification`) }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        cols="12"
      >
        <VTextField
          v-model="form.identifier"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.identifier')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        cols="12"
      >
        <VTextField
          v-model="form.manufacturer"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.manufacturer')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.type"
          :items="displayedTypes"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.type')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        cols="12"
      >
        <VSelect
          v-model="form.operation"
          :items="displayedOperations"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.operation')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        cols="12"
      >
        <VSelect
          v-model="form.regenerationTriggeredBy"
          :items="displayedTrigerredBy"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.regenerationTriggeredBy')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.tankSize.height.value"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.tankSizeHeight')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.tankSize.height.unit"
          :items="displayHeight"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.unite')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.tankSize.diameter.value"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.tankSizeDiameter')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.tankSize.diameter.unit"
          :items="displayDiameter"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.unite')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.resineVolume.value"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.resineVolume')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.resineVolume.unit"
          :items="displayResineVolume"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.unite')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.capacity.value"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.capacity')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.capacity.unit"
          :items="displayCapacity"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.unite')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.brineTankSize.height.value"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.brineTankSizeHeight')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.brineTankSize.height.unit"
          class="text-field-transparent"
          :items="displayHeight"
          :label="$t('technicalFile.SoftPolisherDealk.unite')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.brineTankSize.diameter.value"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.brineTankSizeDiameter')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.brineTankSize.diameter.unit"
          :items="displayDiameter"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.unite')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <p class="xPadding titleModal">
      {{ $t(`history.pageName`) }}
    </p>
    <VTableHistory
      :headers="headers"
      :items="itemsForHistory"
    />
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTableHistory from '@/components/shared/content-views/VTableHistory';
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import _datePickerLocales from '@/locales/date-picker-locales';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect';
import lockService from '@/utilities/lockService';


export default {
    name: 'SoftPolisherDealkTechFile',
    components: {
        VTextField,
        VTableHistory,
        VSelect,
    },
    props: {
        system: {
            type: Object,
            default: () => {},
        },
        parentNode: {
            type: String,
            default: () => '',
        },
        node: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            form: {
                identifier: null,
                type: null,
                operation: null,
                manufacturer: null,
                regenerationTriggeredBy: null,
                tankSize: {
                    height: {
                        value: null,
                        unit: null,
                    },
                    diameter: {
                        value: null,
                        unit: null,
                    },
                },
                resineVolume: {
                    value: null,
                    unit: null,
                },
                capacity: {
                    value: null,
                    unit: null,
                },
                brineTankSize: {
                    height: {
                        value: null,
                        unit: null,
                    },
                    diameter: {
                        value: null,
                        unit: null,
                    },
                },
                history: [],
            },
            units: {
                resineVolume: ['ft3', 'm3'],
                capacity: ['grains', 'liters', 'm3', 'usg', 'impgal'],
                height: ['inches', 'cm'],
                diameter: ['inches', 'cm', 'feet', 'meter'],
            },
            multipleChoices: {
                type: ['simple', 'double', 'polisher', 'other'],
                operation: ['manual', 'automatic'],
                triggeredBy: ['hour/time', 'water volume', 'test result', 'other'],
            },
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
            'hasPermission',
        ]),
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
        headers() {
            return [
                'updatedAt',
                'updatedBy',
                'action',
            ].map(header => ({
                text: this.$t(`forms.history.${header}`),
                value: header,
            }));
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
        itemsForHistory() {
            const copyItems = [...this.form.history];
            const copyItemsFormatted = copyItems.map(item => ({
                updatedBy: `${item.updatedBy.firstName} ${item.updatedBy.lastName}`,
                action: item.action,
                updatedAt: this.$options.filters.formatDate(item.updatedAt, 'L LT'),
            }));
            return copyItemsFormatted;
        },
        displayedTypes() {
            return this.multipleChoices.type.map(name => ({
                name: this.$t(`technicalFile.SoftPolisherDealk.${name}`),
                id: name,
            }));
        },
        displayedOperations() {
            return this.multipleChoices.operation.map(name => ({
                name: this.$t(`technicalFile.SoftPolisherDealk.${name}`),
                id: name,
            }));
        },
        displayedTrigerredBy() {
            return this.multipleChoices.triggeredBy.map(name => ({
                name: this.$t(`technicalFile.SoftPolisherDealk.${name}`),
                id: name,
            }));
        },
        displayResineVolume() {
            return this.units.resineVolume.map(name => ({
                name: this.$t(`technicalFile.SoftPolisherDealk.${name}`),
                id: name,
            }));
        },
        displayCapacity() {
            return this.units.capacity.map(name => ({
                name: this.$t(`technicalFile.SoftPolisherDealk.${name}`),
                id: name,
            }));
        },
        displayHeight() {
            return this.units.height.map(name => ({
                name: this.$t(`technicalFile.SoftPolisherDealk.${name}`),
                id: name,
            }));
        },
        displayDiameter() {
            return this.units.diameter.map(name => ({
                name: this.$t(`technicalFile.SoftPolisherDealk.${name}`),
                id: name,
            }));
        },
    },
    async mounted() {
        this.loading = true;
        await this.getTechFile();
        this.loading = false;
        window.addEventListener('beforeunload', this.handleUnload);
    },
    beforeDestroy() {
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, 'TechnicalFileSoftPolisherDealk');
        }
        window.removeEventListener('beforeunload', this.handleUnload);
    },
    methods: {
        async updateData() {
            await this.$emit('sendData', this.form);
        },
        async getTechFile() {
            const techfile = await this.$rq.getNodeInfo(this.site.id, this.node.ref);
            if (!isEmpty(techfile)) {
                this.form = await { ...this.form, ...techfile.data };
            }
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, 'TechnicalFileSoftPolisherDealk');
            }
        },
    },
};
</script>
  <style lang="scss" scoped>

   .xPadding{
    padding: 0 6rem;
  }

  @media screen and (max-width: 600px) {
     .xPadding{
        padding: 0;
      }
  }
  </style>
